import { css, Theme } from "@emotion/react";

// Block-mode image display: image and text sit side by side from `lg` up.
// The image is locked to this height and its width follows the aspect ratio.
export const BLOCK_IMAGE_HEIGHT = 500;

// The page-edge gutter applied to whichever side faces the page edge, so the
// text and image columns are symmetric. Values mirror ContentContainer's
// existing inline padding-left gutters.
export const blockEdgeGutter = (theme: Theme, side: "left" | "right") => css`
    ${theme.breakpoints.up("lg")} {
        padding-${side}: 45px;
    }

    ${theme.breakpoints.up("xl")} {
        padding-${side}: 81px;
    }

    ${theme.breakpoints.up("3xl")} {
        padding-${side}: 183px;
    }
`;
